<template>
  <div class="contact">
  <div class="landing-1">
    <div class="">
      <div class="col-md-12">
        <h1 class="title-landing">Contact </h1>
      </div>
      <div class="col-md-3">
        <input v-model="form.name" class="input input-contact" type="text" placeholder="Your Name">
      </div>
      <div class="col-md-3">
        <input v-model="form.company" class="input input-contact" type="text" placeholder="Company">
      </div>
      <div class="col-md-3">
        <input v-model="form.pitch" class="input input-contact" type="text" placeholder="Your Pitch">
      </div>
      <div class="col-md-3">
                    <li v-for="(item, k) in form">
                        <strong>{{ k }}:</strong> {{ item }}
                    </li>
      </div>
      <div class="col-md-12">
        <select name="pays" id="pays">
           <option value="france">France</option>
           <option value="espagne">Espagne</option>
           <option value="italie">Italie</option>
           <option value="royaume-uni">Royaume-Uni</option>
           <option value="canada">Canada</option>
           <option value="etats-unis">États-Unis</option>
           <option value="chine">Chine</option>
           <option value="japon">Japon</option>
       </select>
      </div>
    </div>
  </div>
  </div>
</template>

<script scoped>
export default {


    data() {
        return {
            form: {
                name:'',
                company:'',
                pitch:''

            }
        }
    },
computed: {
    getSVGFillColor () {
      return this.isActive ? this.activeFill : this.regularFill
    },
    getButtonBGColor () {
      return this.isActive ? this.regularFill : this.activeFill
    },
    getLabelColor () {
      return this.isActive ? this.activeFill : this.regularFill
    }
  },
  methods: {
    close_menu:function closeNav() {
      this.isActive = !this.isActive
    },
    svgReady () {
      console.log('svg is ready!!')
    }
  }

}





</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input-contact{
      box-sizing: border-box;
  display: block;
  width: 100%;
  height:50px;
  border-width: 1px;
  border-style: solid;
  border-color:white;
  padding: 16px;
  outline: 0;
  font-family: inherit;
  font-size: 0.95em;
  border-radius:3px;
  margin-top:10px;
}
.input-contact:focus{
  border-color:grey;    
}

.animated {
    -webkit-animation-duration: 10s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
}
    
@-webkit-keyframes fadeIn {
    0% {opacity: 0;}
    100% {opacity: 1;}
}
    
@keyframes fadeIn {
    0% {opacity: 0;}
    100% {opacity: 1;}
}
    
.fadeIn {
    -webkit-animation-name: fadeIn;
    animation-name: fadeIn;
}

.card{
    height:200px;
    margin:3px;
    border-radius:4px;
background-color:transparent;
    text-align:center;
}


.title-card{
font-family: Avenir Next, sans-serif;
font-size:17px;
}

.text-card{
font-family: Avenir Next, sans-serif;
font-size:13px;
padding-top:14px;
}



.img-card{
height:90px;
padding-top:10px;
}

.title-landing{
font-family: Avenir Next, sans-serif;
color:white;
font-size:30px;
font-weight:normal;
text-align:center;

}

.text-landing-1{

    width:100%;
}

.landing-1{
background-image: linear-gradient(90deg, #00CCD4 0%, rgb(69, 139, 156) 51%, #6f82c5 100%);
height:900px;
    padding-top:120px;
}

#zindex-neg{
    z-index:-2;
}

#zindex-pos{
 
}

.landing-2{
    background-color:white;
    height:900px;
}





.application{
background-color:white;
left:0;
margin:0;
}

</style>



// WEBPACK FOOTER //
// src/quote.vue